import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { RESTChannel } from "../../model/client-model";

const Constants = {
    FILE: 'FILE',
    FORM_URL_ENCODED: 'FORM_URL_ENCODED',
    FORM_DATA: 'FORM_DATA',
    JSON: 'JSON',
    POST: 'POST',
    PUT: 'PUT',
    RAW: 'RAW',
    REST: 'REST',
    TEXT: 'TEXT',
}

const restMethods = [
    { label: 'POST', value: Constants.POST },
    { label: 'PUT', value: Constants.PUT }
]

const authFormTypes = [
    { label: 'RAW', value: Constants.RAW },
    { label: 'X-WWW-FORM-URLENCODED', value: Constants.FORM_URL_ENCODED },
]

const authReturnTypes = [
    { label: 'TEXT', value: Constants.TEXT },
    { label: 'JSON', value: Constants.JSON },
]

const resourceFormTypes = [
    { label: 'FORM DATA', value: Constants.FORM_DATA },
    { label: 'RAW', value: Constants.RAW },
]

const resourceDataTypes = [
    { label: 'FILE', value: Constants.FILE },
    { label: 'TEXT', value: Constants.TEXT },
]
  
const RESTConfiguration = ({proceedLabel = 'Proceed', show, client, channelField, onBack, onNext, onClose}: any) => {

    const [authFormType, setAuthFormType] = useState<string>(Constants.RAW);
    const [authReturnType, setAuthReturnType] = useState<string>(Constants.TEXT);
    const [resourceFormType, setResourceFormType] = useState<string>(Constants.FORM_DATA);
    
    const [form] = Form.useForm();

    useEffect(() => {

        form.setFieldsValue(client);
        
        if (client && channelField) {
            
            const channel = client[channelField];
            setAuthFormType(channel?.authFormType);
            setAuthReturnType(channel?.authReturnType);
            setResourceFormType(channel?.resourceFormType);

            form.setFieldsValue({
            [channelField]: {
                type: Constants.REST, // Set only the 'type' field of the nested object
            },
        });
        }
        
        
    }, [client]);

    const requiredRule = (isRequired: boolean, message: string) => {
        return {
          required: isRequired,
          message: message,
        }
    }

    const onFinish = (channel: RESTChannel) => {

        const data = {...client, ...channel};
        onNext(data);
    }

    return <Form 
        form={form}
        className="clients-page-form"
        onFinish={onFinish}
        style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}>

        <Form.Item 
            name={[channelField, 'type']}
            style={{display: 'none'}}>
            <Input/>
        </Form.Item>   
  
        <h2>REST Configuration</h2>

        <h3>Authorization Configuration</h3>
         <Row gutter={16}>
            <Col span={6}>
            <label>Method</label>
            <Form.Item
                name={[channelField, 'authMethod']}
                rules={[requiredRule(true, "Method is required.")]}>
                <Select options={restMethods}/>
            </Form.Item>
            </Col>
            <Col span={18}>
                <label>Endpoint</label>
                <Form.Item
                    name={[channelField, 'authEndpoint']}
                    rules={[requiredRule(true,  "Endpoint is required.") ]}>
                    <Input />
                </Form.Item>
            </Col>
        </Row>

        <label>Form Type</label>
        <Form.Item name={[channelField, 'authFormType']}>
            <Select options={authFormTypes} onChange={setAuthFormType} />
        </Form.Item>

        {authFormType === Constants.RAW
        && <Form.Item name={[channelField, 'authBody']}>
            <TextArea />
        </Form.Item>}

        {authFormType === Constants.FORM_URL_ENCODED
        && <Form.List name={[channelField, 'authFormItems']}>
        {(fields, { add, remove }, { errors }) => (
        <>
            {fields.map((field) => {
            return (<Form.Item required={false} key={field.key}>
                <Row gutter={4}>
                    <Col span={10}>
                        <Form.Item name={[field.name, 'name']} validateTrigger={['onBlur']} style={{margin: '0px !important'}}
                            rules={[{required: true, whitespace: true, message: "*"}]}>
                            <Input placeholder="Name" autoComplete="off"/>
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        <Form.Item name={[field.name, 'value']} validateTrigger={['onBlur']} style={{margin: '0px !important'}}>
                            <Input placeholder="Value" autoComplete="off"/>
                        </Form.Item>
                    </Col>
                    <Col span={4} className="flex flex-1 justify-center" style={{margin: '0px !important', marginTop: '.25rem'}}>
                        <Button 
                            type="link" 
                            onClick={() => {remove(field.name);}}>
                            Remove
                        </Button>
                    </Col>
                </Row>
            </Form.Item>)}
            )}
            <Form.Item>
                <Button icon={<FaPlus/>} type="link" onClick={() => {add();}}>
                    Add Value
                </Button>
            </Form.Item>
        </>
        )}
        </Form.List>}

        <label>Return Type</label>
        <Form.Item name={[channelField, 'authReturnType']}>
            <Select options={authReturnTypes} onChange={setAuthReturnType} />
        </Form.Item>

        {authReturnType === Constants.JSON
        && <>
            <label>Access Token Field</label>
            <Form.Item name={[channelField, 'accessTokenField']}>
                <Input />
            </Form.Item>
        </>}

        <h3>Resource Configuration</h3>
         <Row gutter={16}>
            <Col span={6}>
            <label>Method</label>
            <Form.Item
                name={[channelField, 'resourceMethod']}
                rules={[requiredRule(true, "Method is required.")]}>
                <Select options={restMethods}/>
            </Form.Item>
            </Col>
            <Col span={18}>
                <label>Endpoint</label>
                <Form.Item
                    name={[channelField, 'resourceEndpoint']}
                    rules={[requiredRule(true,  "Endpoint is required.") ]}>
                    <Input />
                </Form.Item>
            </Col>
        </Row>

        <label>Form Type</label>
        <Form.Item name={[channelField, 'resourceFormType']}>
            <Select options={resourceFormTypes} onChange={setResourceFormType}/>
        </Form.Item>

        {resourceFormType === Constants.FORM_DATA
        && <Form.List name={[channelField, 'resourceFormItems']}>
        {(fields, { add, remove }, { errors }) => (
        <>
            {fields.map((field) => {
            return (<Form.Item required={false} key={field.key}>
                <Row gutter={4} style={{margin: '0px !important'}}>
                    <Col span={8}>
                        <Form.Item name={[field.name, 'name']} validateTrigger={['onBlur']} style={{margin: '0px !important'}}
                            rules={[{required: true, whitespace: true, message: "*"}]}>
                            <Input placeholder="Name" autoComplete="off"/>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name={[field.name, 'dataType']} validateTrigger={['onBlur']} style={{margin: '0px !important'}}
                            rules={[{required: true, whitespace: true, message: "*"}]}>
                            <Select options={resourceDataTypes}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={[field.name, 'value']} validateTrigger={['onBlur']} style={{margin: '0px !important'}}>
                            <Input placeholder="Value" autoComplete="off"/>
                        </Form.Item>
                    </Col>
                    <Col span={4} className="flex flex-1 justify-center" style={{marginTop: '.25rem'}}>
                        <Button 
                            type="link" 
                            onClick={() => {remove(field.name);}}>
                            Remove
                        </Button>
                    </Col>
                </Row>
            </Form.Item>)}
            )}
            <Form.Item>
                <Button icon={<FaPlus/>} type="link" onClick={() => {add();}}>
                    Add Value
                </Button>
            </Form.Item>
        </>
        )}
        </Form.List>}
        
        <Space direction="horizontal" align="end" style={{marginTop: '2rem', width: '100%', justifyContent: 'flex-end'}}>
            <Button type="default" key="cancel" onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onBack}>Back</Button>
            <Button type="primary" htmlType="submit">{proceedLabel}</Button>
        </Space>
    </Form>
}

export default RESTConfiguration;